import React, { Component } from "react";
//import Translation from '../modules/translation'

class Pager extends Component {
    // constructor(props) {
    //     super(props);

    // }

    render() {
        var page = parseInt(this.props.page, 10);
        var pageSize = parseInt(this.props.pageSize, 10);
        var count = parseInt(this.props.count, 10);
        var lastPage = Math.floor(count / pageSize) + (count % pageSize !== 0 ? 1 : 0);

        var minPage = Math.max(1, page - 3);
        var maxPage = Math.min(lastPage, page + 4);
        while (maxPage - minPage < 7) {
            if (minPage > 1) {
                minPage--;
            }
            if (maxPage - minPage < 7 && maxPage < lastPage) {
                maxPage++;
            }
            if (minPage === 1 && maxPage === lastPage) break;
        }

        var pages = [];
        for (var i = minPage; i <= maxPage; i++) pages.push(i);
        return (
            <div className="d-flex align-items-center justify-content-between">
                <div className="row">
                    <div className="col-md-12">
                        {this.props.count} {this.props.T("recordsfound")}
                    </div>
                </div>

                {minPage < maxPage ? (
                    <nav aria-label="Page navigation example">
                        <ul className="pagination mb-0">
                            <li className="page-item">
                                {page > 2 ? (
                                    <button className="page-link" onClick={() => this.props.GotoPage(1)}>
                                        <i className="fas fa-step-backward"></i>
                                    </button>
                                ) : null}
                            </li>
                            <li className="page-item">
                                {page > 1 ? (
                                    <button className="page-link" onClick={() => this.props.IncPage(-1)}>
                                        <i className="fas fa-caret-left"></i>
                                    </button>
                                ) : null}
                            </li>
                            {pages.map((item) =>
                                item === page ? (
                                    <li className="page-item active">
                                        {<button className="page-link">{item}</button>}
                                    </li>
                                ) : (
                                    <li className="page-item">
                                        {
                                            <button
                                                className="page-link"
                                                onClick={() => this.props.GotoPage(item)}
                                            >
                                                {item}
                                            </button>
                                        }
                                    </li>
                                )
                            )}
                            <li className="page-item">
                                {page < lastPage ? (
                                    <button className="page-link" onClick={() => this.props.IncPage(1)}>
                                        <i className="fas fa-caret-right"></i>
                                    </button>
                                ) : null}
                            </li>
                            <li className="page-item">
                                {page < lastPage - 1 ? (
                                    <button
                                        className="page-link"
                                        onClick={() => this.props.GotoPage(lastPage)}
                                    >
                                        <i className="fas fa-step-forward"></i>
                                    </button>
                                ) : null}
                            </li>
                        </ul>
                    </nav>
                ) : null}
            </div>
            // <div>
            //     <div className="row">
            //         <div className="col-md-12">
            //             {this.props.count} {this.props.T('recordsfound')}
            //         </div>
            //     </div>
            //     {
            //         minPage < maxPage ?
            //             <div className="row">
            //                 <div className="col-md-1">
            //                     {
            //                         page > 2 ?
            //                             <button className="btn btn-default" onClick={() => this.props.GotoPage(1)}>
            //                                 <i className="fas fa-step-backward"></i>
            //                             </button>
            //                             : null
            //                     }

            //                 </div>
            //                 <div className="col-md-1">
            //                     {
            //                         page > 1 ?
            //                             <button className="btn btn-default" onClick={() => this.props.IncPage(-1)}>
            //                                 <i className="fas fa-caret-left"></i>
            //                             </button>
            //                             : null
            //                     }
            //                 </div>
            //                 {
            //                     pages.map(
            //                         item =>
            //                             <div className="col-md-1">
            //                                 {
            //                                     item === page ? <span>{item}</span> :

            //                                         <button className="btn btn-default" onClick={() => this.props.GotoPage(item)}>
            //                                             {item}
            //                                         </button>
            //                                 }
            //                             </div>

            //                     )

            //                 }
            //                 <div className="col-md-1">
            //                     {
            //                         page < lastPage ?
            //                             <button className="btn btn-default" onClick={() => this.props.IncPage(1)}>
            //                                 <i className="fas fa-caret-right"></i>
            //                             </button>
            //                             : null
            //                     }
            //                 </div>
            //                 <div className="col-md-1">
            //                     {
            //                         page < lastPage - 1 ?
            //                             <button className="btn btn-default" onClick={() => this.props.GotoPage(lastPage)}>
            //                                 <i className="fas fa-step-forward"></i>
            //                             </button>
            //                             : null
            //                     }
            //                 </div>
            //             </div>
            //             : null

            //     }
            // </div>
        );
    }
}

export default Pager;



// WEBPACK FOOTER //
// ./src/controls/pager.js